import { queryBot, queryBot2, queryBot2Many } from 'boot/axios';
import { isFlowVisible } from 'src/model/helpers';
import resultService from 'src/services/result.service';
import { Notify } from 'quasar';
import { parseJson } from 'src/mixins/utils';
import { calculateTestResult } from 'src/model/testActivities';

const starsService = {
    async updateUserStars (userId) {
        const checkQuestions = (question) => {
            // eslint-disable-next-line no-confusing-arrow
            const unanswered = _.find(question.subquestions, (s) => !s.response);
            const answered = _.filter(question.subquestions, (s) => s.response);
            if (unanswered) {
                if (+question.maxQuestions === 0) return false;
                if (answered.length < +question.maxQuestions) return false;
            }

            const sumResult = calculateTestResult.getSumResult(question.subquestions);
            const userQuestionsLength = question.subquestions.slice(0, +question.maxQuestions || question.subquestions.length).length || 1;
            question.score = ((sumResult * 100) / userQuestionsLength).toFixed(0);
            if (question.score > 100) question.score = 100;

            return question.score >= +question.success_score && question.score > 0;
        };
        const checkExercise = (question) => {
            question.score = question.passed === '1' ? 100 : 0;
            return question.passed === '1';
        };
        const checkInteractive = (question) => {
            question.score = +question.response?.result ? 100 : 0;
            return !!question.response?.result;
        };
        const getCheckFunction = (question) => {
            if (!question) return false;

            if (question.question.type === 'questions') {
                return checkQuestions;
            }

            const exercise = question.question.type === 'exercise';
            const sql = question.question.type === 'SQLexercise';
            const code = question.question.type === 'CodeExercise';
            const ptf = question.question.type === 'portfolio';
            if (exercise || sql || code || ptf) {
                return checkExercise;
            }

            const interactive = question.question.type === 'interactive';
            if (interactive) {
                return checkInteractive;
            }
            return null;
        };

        const userResp = await queryBot2('get-user-by-id', { id: userId });
        const user = _.first(userResp.data);
        const courseId = user.last_course_id;
        const flowResp = await queryBot2('get-user-flow-num', { userId, courseId });
        const flowNum = flowResp.data[0]?.flow_num;

        const data = await queryBot2Many('get-questions-advanced', { userId, courseId, chatId: user.chat_id });
        if (_.isArray(data) && data.length > 0) {
            const questions = [];

            // init questions
            _.each(data, (q) => {
                q.question = parseJson(q.question);
                if (q.answer?.length > 0) q.response = parseJson(q.answer);
                q.subquestions = [];

                if (['questions', 'interactive', 'exercise', 'SQLexercise', 'CodeExercise', 'portfolio'].includes(q.question.type) && q.question.selfCheck !== '1') {
                    try {
                        if (q.visible_for_flows) {
                            if (!isFlowVisible(flowNum, q.visible_for_flows, user.hashtags)) return true;
                        }

                        const visibility = parseJson(q.visibility_json);
                        const { flows } = visibility;
                        if (flows) {
                            if (!isFlowVisible(flowNum, flows, user.hashtags)) return true;
                        }

                        questions.push(q);
                    } catch {
                        console.warn('visibility_json parse error');
                    }
                    q.checkFunc = getCheckFunction(q);
                    q.score = 0;
                }
                return true;
            });
            for (let i = 0; i < questions.length; i += 1) {
                const q = questions[i];
                if (q.question.type === 'questions') {
                    const parent = _.find(questions, (item) => +item.qid === +q.qid);
                    const dum = await queryBot2Many('get-test-questions-answers', { chatId: user.chat_id, activityId: parent.qid });
                    parent.subquestions = _.map(dum, (item) => ({
                        question: item,
                        response: item.answer?.length > 0 ? parseJson(item.answer) : null,
                    }));
                }
            }

            let result = 0;
            for (let i = 0; i < questions.length; i += 1) {
                const question = questions[i];
                question.checkFunc(question);
                let score = +question.score;
                let stars = _.isNull(question.qStars) ? null : +question.qStars;
                if (['exercise', 'SQLexercise', 'CodeExercise', 'portfolio'].includes(question.question.type)) {
                    stars = +question.eStars;
                }
                let temp = null;
                if (_.isNumber(stars)) {
                    temp = (score * stars) / 100;
                    temp = +temp.toFixed(0);
                    if (score < +question.success_score) temp = 0;
                    result += temp;
                    question.myStars = _.isNull(question.myStars) ? question.myStars : +question.myStars;
                }
                if (score > 100) score = 100;
                // console.log('*', question.qid, question.question.text, question.question.type, 'score', score, 'max', stars, 'add', temp, +question.myStars, 'sum stars', result);
                if (+question.srid > 0 && (temp !== question.myStars && score > +question.myScore)) {
                    // console.log('update-slide-result', {
                    //     userId,
                    //     slideId: question.qid,
                    //     score,
                    //     stars: temp,
                    //     success: Number(score > 0),
                    // });
                    await queryBot2('update-slide-result', {
                        userId,
                        slideId: question.qid,
                        score,
                        stars: temp,
                        success: Number(score >= +question.success_score),
                    });
                }
            }
            // console.log('stars update result', result, 'userId', userId);
            await queryBot2('update-user-cour-stars', { stars: result, userId, courseId });
        }
        return true;
    },

    async updateQuestionStars (slideId, taskId) {
        const resp = await queryBot2('get-users-slide-results', { slideId });
        const notif = Notify.create({
            group: false, //
            timeout: 0,
            spinner: true,
            message: 'Пересчет звезд пользователей...',
            caption: '',
        });
        for (let i = 0; i < resp.data.length; i += 1) {
            notif({ caption: `${i} из ${resp.data.length}` });
            const item = resp.data[i];
            await starsService.updateUserStars(item.userId);
            await resultService.updateTaskResult(taskId, item.userId);
        }
        notif({
            icon: 'done',
            spinner: false,
            message: 'Завершено обновление звезд',
            timeout: 2000,
        });
    },

    async getUserStars (userId, courseId) {
        const { data } = await queryBot(`select stars from user_courses where user_id = '${userId}' and course_id = '${courseId}'`);
        const [row] = data;
        if (row) {
            return row.stars;
        }
        return 0;
    },
};

export default starsService;
